<template>
  <nav class="main-navigator" :class="{ scrolled: $store.state.page.scrolled }">
    <div class="menu-icon__wrapper">
      <div
        class="menu-icon"
        :class="{ 'hover': hover }"
        data-apollo-hover
        data-apollo-hover-animation="scale-center"
      >
        <div class="menu-icon__line"></div>
        <div class="menu-icon__line"></div>
        <div class="menu-icon__line"></div>
      </div>
      <div
        class="menu-icon__interaction"
        @click="toggleMenu"
        @mouseover="hover = true"
        @mouseout="hover = false"
      ></div>
    </div>
    <div class="menu-voices" @mouseleave="resetLine">
      <MenuLabel :label="'Manifesto.'" :to="'/manifesto'" />
      <MenuLabel :label="'Social.'" :to="'/social'" />
      <MenuLabel :label="'What\'s New.'" :to="'/whats-new'" />
      <MenuLabel :label="'Prosecco.'" :to="'/collection/cuvee-1821'" class="last" />

      <div class="menu-voices__line" ref="line"></div>
    </div>
  </nav>
</template>

<script>
import { TweenMax, Power3 } from 'gsap/TweenMaxBase';
import MenuLabel from '@/components/frame/MenuLabel.vue';
import animations from '@/assets/animations';

export default {
  name: 'MainNavigator',

  components: {
    MenuLabel,
  },

  data() {
    return {
      menuTimeline: null,
      menuAnimating: false,
      hover: false,
    };
  },

  mounted() {
    const background = document.querySelector('.menu__background');
    TweenMax.set(background, { yPercent: 100 });
    this.$eventHub.$on('menu-navigate', this.navigate);
    this.$eventHub.$on('menu-voice-enter', this.moveLine);
    this.$eventHub.$on('menu-voice-leave', this.resetLine);
    this.$nextTick(() => this.resetLine());
    this.$eventHub.$on('menu-navigate', () => { this.toggleMenu(); });
    this.$eventHub.$on('close-menu', () => { this.closeMenu(); });
  },

  methods: {
    navigate(event) {
      this.$router.push(event.url);
      this.resetLine();
    },
    toggleMenu() {
      if (this.menuAnimating) return;
      this.menuAnimating = true;
      if (!this.$store.state.menu.open) {
        this.menuTimeline = animations.get('menu-open')(this.$el);
        this.menuTimeline.eventCallback('onComplete', () => { this.menuAnimating = false; });
        this.menuTimeline.eventCallback('onReverseComplete', () => { this.menuAnimating = false; });
        this.$store.commit('SET_MENU_OPEN', true);
        this.menuTimeline.play();
      } else {
        this.$store.commit('SET_MENU_OPEN', false);
        this.menuTimeline.reverse();
      }
    },
    closeMenu() {
      if (this.$store.state.menu.open) {
        this.$store.commit('SET_MENU_OPEN', false);
        this.menuTimeline.reverse();
      }
    },
    moveLine(event) {
      TweenMax.to(this.$refs.line, 0.6, {
        x: event.e.getBoundingClientRect().left - event.e.parentNode.parentNode.getBoundingClientRect().left,
        scaleX: event.e.getBoundingClientRect().width + ((window.innerWidth / 32) * 2),
        transformOrigin: '0% 50%',
        ease: Power3.easeOut,
      });
    },
    resetLine() {
      const e = this.$el.querySelector('.router-link-active');
      if (!e) {
        TweenMax.to(this.$refs.line, 0.6, {
          x: 0,
          scaleX: 0,
          ease: Power3.easeOut,
        });
      } else {
        TweenMax.to(this.$refs.line, 0.6, {
          x: e.getBoundingClientRect().left - e.parentNode.getBoundingClientRect().left,
          scaleX: e.getBoundingClientRect().width + ((window.innerWidth / 32) * 2),
          transformOrigin: '0% 50%',
          ease: Power3.easeOut,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-navigator {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  @include mq($until: ipadL) {
    justify-content: flex-end;
  }

  &.scrolled .menu-voices__line {
    opacity: 0;
  }

  .menu-icon__wrapper {
    position: relative;
    width: calc((100vw / 32) * 1);

    @include mq($until: ipadP) {
      width: calc((100vw / 32) * 4);
      display: flex;
      justify-content: flex-end;
    }

    .menu-icon__interaction {
      position: absolute;
      width: 50px;
      height: 50px;
      left: 25%;
      top: 50%;
      transform: translateX(-25px) translateY(-50%);
      cursor: pointer;

      @include mq($until: ipadP) {
        left: 75%;
      }

      @at-root .menu-open & {
        width: calc(75px + (100vw / 32) * 1);

        @include mq($until: ipadP) {
          width: calc(100px + (100vw / 32) * 1);
          right: -100%;
          left: auto;
        }
      }
    }
  }

  .menu-icon {
    position: relative;
    width: 20px;
    height: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    &__line {
      height: 2px;
      width: 100%;
      background-color: $color-white;
      transition: background-color .6s $inOutCubic,
                  width .3s $inOutCubic;

      @at-root .menu-open & {
        background-color: $color-primary;
      }

      @at-root .page-white & {
        background-color: $color-primary;
      }

      &:nth-child(1) {
        width: 40%;
        align-self: flex-end;
      }

      &:nth-child(3) {
        width: 40%;
        align-self: flex-start;
      }
    }

    &.hover .menu-icon__line {
      &:nth-child(1),
      &:nth-child(3) {
        width: 100%;
      }
    }
  }

  .menu-voices {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-grow: 1;
    margin-left: calc((100vw / 32) * 1);

    @include mq($until: ipadL) {
      display: none;
    }

    .menu-voices__line {
      position: absolute;
      bottom: calc((100vw / 32) * -1);
      height: 2px;
      background-color: $color-white;
      width: 1px;
      transition: background-color .6s $inOutCubic,
                  opacity .6s $inOutCubic;
      transform-origin: 0px 50%;

      @at-root .page-white & {
        background-color: $color-primary;
      }

      @at-root .page-black & {
        background-color: $color-white;
      }
    }
  }
}
</style>
